///////////////////AuthListener.tsx 
import { useEffect } from 'react';
import { getCurrentUser } from './AppWrite';
import userStateManager from './UserStateManager';

const AuthListener = () => {


  useEffect(() => {
    // შემოწმება ხდება გვერდის ჩატვირთვისას 
    // ან OAuth რედირექტის შემდეგ
    const checkAuthStatus = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
        //   console.log('User is authenticated:', user);
          
          // UserStateManager-ში მომხმარებლის მდგომარეობის განახლება
          userStateManager.setUser({
            external_Id: user.external_Id,
            first_name: user.first_name,
            profile_img: user.profile_img,
            user_type: user.user_type,
            email: user.email
          });
          
          // შევამოწმოთ არის თუ არა ეს OAuth რედირექტი
          const url = new URL(window.location.href);
          
          // თუ ეს მომხმარებელი ახლა დაბრუნდა OAuth-დან (URL-ში არის oauth-დაკავშირებული პარამეტრი)
          // ან ქუკიში ან სხვა ადგილას შევინახოთ ეს სტატუსი
          if (url.searchParams.has('code') || url.searchParams.has('state') || url.hash.includes('access_token')) {
            // console.log('User returned from OAuth, redirecting to google-account page');
            
            // URL-ის გასუფთავება ისტორიიდან
            window.history.replaceState({}, document.title, window.location.pathname);
            
            
            // მცირე დაყოვნებით, რათა საჭიროების შემთხვევაში ვებ-გვერდი თავიდან ჩაიტვირთოს
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        } 
      } catch (error) {
        console.error('Auth check failed:', error);
      }
    };

    checkAuthStatus();
  }, []);

  // კომპონენტი არ აბრუნებს UI ელემენტებს
  return null;
};

export default AuthListener;


